// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"Fieldset_fieldset__x5JnT","water":"Fieldset_water__zsY4k","rotate":"Fieldset_rotate__giq2U","pulsate":"Fieldset_pulsate__qhqet"};